import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaRegEye } from "react-icons/fa";
import { FaCircleXmark } from "react-icons/fa6";
import BeatLoader from "react-spinners/BeatLoader";
// import { useChangePasswordMutation } from "../../Data/services/settingApi";
import { Button, Description, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import { useChangeUserPasswordMutation } from "../../Data/services/generalUserApi";
import _ from "lodash";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import { useChangeUserPassMutation } from "../../Data/services/userApi";
import ClipLoader from "react-spinners/ClipLoader";

const ChangePasswordModal = ({
  handleBlockModalClose,
  data,
  onAction,
  loading,
  forBlock,
}) => {
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm();

  console.log(data);

  const [showPassword, setShowPassword] = useState(false);

  const [changePassword, { isLoading }] = useChangeUserPassMutation();

  const handleDataSubmission = async (updatedData) => {
    // console.log("handleDataSubmission0");
    console.log(updatedData.new_password);
    if (_.isEmpty(updatedData.new_password)) {
      return Toast("Password is required", "error");
    }

    console.log(updatedData);
    // return;
    try {
      const response = await changePassword({
        data: updatedData,
        id: data.id,
      }).unwrap();

      console.log(response);

      if (response.code === 200) {
        SuccessToast(response?.message);
        handleBlockModalClose();
      }
    } catch (error) {
      console.log(error);
      if (error && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <ModalContainer handleClose={handleBlockModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 ">Change Password </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleBlockModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100 ">
            <p>
              User : <b>{data?.email}</b>
            </p>

            <Form onSubmit={handleSubmit(handleDataSubmission)}>
              <Description text="Set New Password" classes="mt-3 mb-1" />

              <Controller
                control={control}
                name="new_password"
                rules={{ required: "New Password is required." }}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <div className=" position-relative">
                    <Input
                      placeholder="New Password"
                      type={showPassword ? "text" : "password"}
                      onChange={onChange}
                      value={value}
                    />
                    <span
                      className="input-after-icon"
                      onClick={handleShowPassword}
                    >
                      <FaRegEye color={showPassword ? "blue" : ""} />
                    </span>
                  </div>
                )}
              />

              <div className="w-100">
                <Button
                  text={
                    // "Change Password"
                    isLoading ? (
                      <ClipLoader color="#0f0f0f" size="22px" />
                    ) : (
                      "Change Password"
                    )
                  }
                  classes={`fs-6 mb-2 mt-auto mt-3 mb-2 
                    ${isLoading || !isValid ? "bg-dark-subtle" : ""}
                `}
                  // classes={`fs-6 mb-2 mt-auto mt-3 mb-2`}
                  disabled={isLoading || !isValid}
                  type="submit"
                />
              </div>
            </Form>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ChangePasswordModal;
